export default "__VITE_ASSET__3SwdttSl__";